import { customType } from 'drizzle-orm/sqlite-core'
import { z } from 'zod'

export const PORTAL_PLAYER_TIER_PRICING_MODES = ['flat_per_day', 'scheduled'] as const
export type TPortalPlayerTierPricingMode = typeof PORTAL_PLAYER_TIER_PRICING_MODES[number]

export const portalPlayerTierPricingModeSchema = z.enum(PORTAL_PLAYER_TIER_PRICING_MODES)

export const portalPlayerTierPricingModeType = customType<{
  data: TPortalPlayerTierPricingMode
  notNull: true
  default: true
}>({
  dataType() {
    return 'text'
  },
  fromDriver(value) {
    const parsed = portalPlayerTierPricingModeSchema.safeParse(value)
    if (!parsed.success) {
      throw new Error(`Invalid portal player tier pricing mode: ${value}`)
    }
    return parsed.data
  }
})
